;(function($, window, document){
    window.HeaderMobile = Me.view.extend({
        options: {
        },

        initialize: function() {
            _.bindAll(this, 'breakpointHandler', 'scrollHandler', 'closeSearch', 'keypressHandler', 'launchSearch', 'resizeHandler', 'searchHandler', 'toggleMobileSubmenu', 'updateActiveLink', 'displayMobileMenu', 'updateCartCount', 'closeSubmenu', 'closeMobileMenu', 'resetHeaderTop', 'toggleMobileSubmenu2ndLevel');
            this.updateActiveLink();
            this.addEvents();
        },
        addEvents: function() {
            this.$('.nav-wrapper>ul>li>a').on('click', this.toggleMobileSubmenu);
            this.$('.nav-wrapper>ul>li .subtitle').on('click', this.toggleMobileSubmenu2ndLevel);
            this.$('.nav-trigger').on('click', this.displayMobileMenu);
            this.$('.back-btn').on('click', this.closeSubmenu);
            this.$('.icon.search').on('click', this.searchHandler);
            Me.dispatch.subscribe('Cart.quantityUpdated', this.updateCartCount);
            Me.dispatch.subscribe('breakpointChanged', this.breakpointHandler);
            Me.dispatch.subscribe('banner.changed', this.resetHeaderTop);
            Me.dispatch.subscribe('page.scroll', this.scrollHandler);
        },
        breakpointHandler: function(e, params){
            if(params.breakpoint != '767-' && params.breakpoint != '768-1023' && params.breakpoint != '1024-1024'){
                this.closeMobileMenu($('body'));
                $(window).off('resize', this.resizeHandler)
            }else{
                $(window).on('resize', this.resizeHandler)
            }
            this.resizeHandler();
        },

        closeSearch: function(e){
            if($(e.target).parents('#header-mobile').length == 0){
                this.$('.search-field').css('height', 0);
                this.$el.removeClass('searching');
                $('body').off('click', this.closeSearch);
                $(window).off('keydown', this.keypressHandler);
            }
        },
        closeSubmenu: function(e){
            if(this.$('nav').hasClass('submenu-open-2nd-level')){
                $(e.currentTarget).parents('ul').removeClass('active');
                this.$('nav').removeClass('submenu-open-2nd-level');
            }else{
                $(e.currentTarget).parents('li').removeClass('active');
                this.$('nav').removeClass('submenu-open');
            }
        },
        displayMobileMenu: function(){
            var view = this;
            this.options.scrollTop = $(window).scrollTop();

            $('body').addClass('mobile-menu-open');
           /* $('html, body').css('overflow','hidden');*/

            $('#site-ctn #site-content-wrapper').css({
                'top':  -this.options.scrollTop
            });

          
            this.$('.nav-trigger').off('click', this.displayMobileMenu);

            setTimeout(function(){
                $('body').on('click', view.closeMobileMenu);
            },10);
        },
        closeMobileMenu: function(e){
            if(!$(e.target).hasClass('mobile-nav') && $(e.target).parents('.mobile-nav').length == 0 ){
                $('body').removeClass('mobile-menu-open');
                $('html, body').css('overflow','');
              
                $('#site-ctn #site-content-wrapper').css('top', '');
              
    
                $(window).scrollTop(this.options.scrollTop);

                this.options.scrollTop = 0;
                this.$('nav').removeClass('submenu-open submenu-open-2nd-level');
                this.$('nav .active').removeClass('active');
                $('body').off('click', this.closeMobileMenu);
                this.$('.nav-trigger').on('click', this.displayMobileMenu);
            }
        },
        keypressHandler: function(e){
            if(e.keyCode == 27){
                //escape
                this.closeSearch($('body'));
            }else if(e.keyCode == 13){
                //enter: search
                this.launchSearch();
            }
        },
        launchSearch: function(){
            location = this.$('.icon.search').attr('data-search-service') + this.$('input').val();
        },
        resetHeaderTop: function(){
            this.resizeHandler();
        },
        resizeHandler: function(){
            if($('#site-ctn').hasClass('has-info-banner') && !$('.info-banner').hasClass('hide')){
                this.$('.mobile-nav').css('top', $('.info-banner').outerHeight(true));
            }else{
                this.$('.mobile-nav').css('top',0);
            }
        },
        scrollHandler: function(){
            var bodyScrollTop = Math.max(document.scrollingElement.scrollTop, document.documentElement.scrollTop);

            if($('body').hasClass('mobile-menu-open')){
                return;
            }

            if($('.info-banner').length != 0){
                if(bodyScrollTop >= $('.info-banner').height()){
                    //this.$el.css({'position': 'fixed'});
                  //  $('#site-ctn').css({'margin-top': '50px'})

                }else{
                   // this.$el.css({'position': 'fixed'});
                   // $('#site-ctn').css({'margin-top': '50px'})
                }
            }
            else if(bodyScrollTop >= this.$el.offset().top){
                //this.$el.css({'position': 'fixed'});
                //$('#site-ctn').css({'margin-top': '50px'})
            }else{
               // this.$el.css({'position': 'fixed'});
                //$('#site-ctn').css({'margin-top': '50px'})
            }
        },
        searchHandler: function(){
            var view = this;
            if(this.$el.hasClass('searching')){
                this.launchSearch();
            }else{
                this.$('.search-field').css('height', 50);

                setTimeout(function(){
                    view.$el.addClass('searching');
                    $('body').on('click', view.closeSearch);
                    view.$('input').trigger('focus');
                    $(window).on('keydown', view.keypressHandler);
                }, 10)

            }
        },
        toggleMobileSubmenu: function(e){
            if($(e.currentTarget).parents('li').find('.submenu').length != 0){
                this.$('nav').addClass('submenu-open');
                $(e.currentTarget).parents('li').addClass('active');
            }
        },
        toggleMobileSubmenu2ndLevel: function(e){
            $(e.currentTarget).parent().addClass('active');
            this.$('nav').addClass('submenu-open-2nd-level');
        },
        updateCartCount: function(e, params){
            this.$('.icon.cart span').text(params.quantity);
            if(params.quantity == 0){
                this.$('.icon.cart span').addClass('hide');
            }
        },
        updateActiveLink: function(){
            this.$('ul li').each(function(index,value){
                if($(value).find('li.current-page').length != 0){
                    $(value).addClass('current-page');
                }
            })
        }
    });
}(jQuery, window, document));
